import {mapProps, withProps} from 'recompose'

import compose from 'lodash/flowRight'
import {connect} from 'react-redux'
import {useParams} from 'react-router-dom'

import withHook from '../../../hocs/withHook'
import {withBranchProps} from '../../../hooks/routes'
import type {State} from '../../../reducers/types'
import {withLocation} from '../../../routes'
import {getBuildType, getProject} from '../../../selectors'
import {toBuildTypeId, toProjectId, toTestId} from '../../../types'
import {queryToObject} from '../../../utils/queryParams'

import TestHistoryPage from './TestHistoryPage'
import {TestPageTabNamesEnum} from './TestHistoryPage.tabs'
import type {OwnProps, StateProps, ComposeProps} from './TestHistoryPage.types'

const mapStateToProps = (
  state: State,
  {projectId, buildTypeId}: OwnProps & ComposeProps,
): StateProps => {
  const {internalId: projectInternalId, name: projectName} = getProject(state, projectId) ?? {}
  const {name: buildTypeName} = getBuildType(state, buildTypeId) ?? {}
  return {
    projectInternalId,
    projectName,
    buildTypeName,
  }
}

export default compose(
  withHook(useParams),
  withLocation,
  withBranchProps,
  withProps(({location}) => {
    const defaultTab = TestPageTabNamesEnum.OVERVIEW
    const query = queryToObject(location?.search)
    return {
      currentTab: query.testTab ?? defaultTab,
      projectId: query.currentProjectId,
      buildTypeId: query.currentBuildTypeId,
    }
  }),
  mapProps(
    ({testId, projectId, buildTypeId, currentTab, ...restProps}: OwnProps & ComposeProps) => ({
      testId: toTestId(testId),
      projectId: projectId != null ? toProjectId(projectId) : null,
      buildTypeId: buildTypeId != null ? toBuildTypeId(buildTypeId) : null,
      currentTab: currentTab != null ? currentTab : null,
      ...restProps,
    }),
  ),
  connect(mapStateToProps),
)(TestHistoryPage)
